export default __webpack_public_path__ + "static/media/icon-colour-light-background.5573ce1f.svg";